import React, { useState, useEffect, useRef } from "react";
import Card from "../../StyledComponents/Card/Card";
import CardText from "../../StyledComponents/Card/CardText";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import { boxShadow } from "../../StyledComponents/material-dashboard-pro-react";
import {
  Autocomplete,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TablePagination,
  TextField,
  Typography,
} from "@material-ui/core";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import CardBody from "../../StyledComponents/Card/CardBody";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { getVendorDetail } from "../Invoices/actions";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import { makeStyles } from "@material-ui/styles";
import { Link } from "react-router-dom";
import { Refresh } from "@material-ui/icons";
import InvoiceTable from "../Home/InvoiceTable";
import VendorFinancingLCTable from "./vendorFinancingLcTable";
import { getBankDetail, getLcsLandingPage } from "./actions";
import moment from "moment";
import { getBankName } from "../../Functions/functions";
const useStyles = makeStyles(dashboardStyle);
const VendorFinancingLc = () => {
  const [vendors, setVendors] = useState([]);

  const [vendorLoading, setVendorLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [vendorLcs, setLcs] = useState([]);
  const [lcLoading, setLcsLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);
  const [bankDetailsLoading, setBankDetailsLoading] = useState(false);

  const [formState, setFormState] = useState({
    Vendor: {
      Vendor_Code: "-1",
      Vendor_Name: "All",
    },
    isAsc: "true",
    RowsOfPage: 25,
    PageNo: 1,
  });
  useEffect(() => {
    getVendorDetail(null, setVendors, setVendorLoading);
  }, [formState?.Vendor?.Vendor_Code]);

  useEffect(() => {
    getLcsLandingPage(setLcs, setLcsLoading, formState, setCount);
  }, [
    formState?.PageNo,
    formState?.RowsOfPage,
    formState?.Generic,
    formState?.isAsc,
  ]);
  useEffect(() => {
    if (vendors.length > 0 && vendors[0].Vendor_Code !== "-1") {
      const vendorsStrigify = JSON.stringify(vendors);

      const vendorsParse = JSON.parse(vendorsStrigify);

      vendorsParse.unshift({ Vendor_Code: "-1", Vendor_Name: "All" });

      setVendors(vendorsParse);
    }
  }, [vendors]);

  const classes = useStyles();

  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));

    if (name === "Vendor") {
      const updatedFormState = {
        ...formState,
        [name]: value,
      };
      getLcsLandingPage(setLcs, setLcsLoading, updatedFormState, setCount);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setFormState((formState) => ({
      ...formState,
      RowsOfPage: event.target.value,
    }));
  };

  const handleChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      PageNo: newPage + 1,
    }));
  };
  const refreshLCS = () => {
    getLcsLandingPage(setLcs, setLcsLoading, formState, setCount);
  };
  useEffect(() => {
    getBankDetail(null, setBankDetails, setBankDetailsLoading);
  }, []);

  const exportVendorLcsToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Vendor LCs');

    // Define the headers for the table
    const headers = [
        { label: 'LC ID', key: 'lC_Id' },
        { label: 'Vendor Code', key: 'vendor_Code' },
        { label: 'Vendor Name', key: 'vendor_Name' },
        {label:'Bank Name',key:'bank_Id'},
        { label: 'LC Bank Reference #', key: 'lC_Bank_Reference_num' },
        { label: 'LC Amount', key: 'lC_Amount' },
        { label: 'Utilized Amount', key: 'utilizes_Amount' },
        { label: 'Available', key: 'available_Amount' },
        { label: 'Maturity Period', key: 'maturity_Period' },
        { label: 'Issuance Date', key: 'issuance_Date' },
        { label: 'Expiry Date', key: 'expiry_Date' },
    ];
// {getBankName(bankDetails, item?.["bank_Id"])}
    // Add headers to worksheet
    const headerRow = worksheet.addRow(headers.map(header => header.label));

    // Apply bold font to the header row
    headerRow.font = { bold: true };

    // Iterate over vendorLcs to add data rows
    vendorLcs.forEach(lc => {
        // Map data to the row based on headers (using key from header definition)
        const row = headers.map(header => lc[header.key]);

        // Add data row to the worksheet
        const excelRow = worksheet.addRow(row);

        // Format the cells (optional)
        row.forEach((cell, colIndex) => {
        
            const cellRef = excelRow.getCell(colIndex + 1);
            if (colIndex=='3') {
              console.log(colIndex,headers[colIndex],cell,bankDetails)
              const bankname=getBankName(bankDetails,cell)
              cellRef.value=bankname
            }
            if (colIndex=='9'||colIndex=='10') {
                const date = moment(cell);
                if (date.isValid()) {
                  const formattedDate = date.format("DD-MMM-YYYY");
                  cellRef.numFmt = "DD-MMM-YYYY";
                  cellRef.value = formattedDate;
                } else {
                  cellRef.value = "Invalid Date";
                }
            }

            if (headers[colIndex].key.toLowerCase().includes('amount') && typeof cell === 'number') {
                cellRef.numFmt = '#,##0.00';
            }

            // Add borders to each cell
            cellRef.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
    });

    // Set column widths dynamically based on the longest content in each column
    worksheet.columns = headers.map(header => {
        const maxLength = Math.max(
            ...vendorLcs.map(lc => String(lc[header.key]).length),
            header.label.length
        );
        return { width:header.key=='lC_Amount'?maxLength + 5: maxLength + 4 }; // Add some padding for readability
    });

    // Generate buffer and download the file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Trigger file download
    saveAs(blob, 'Vendor_LCs_Report.xlsx');
};



  return (
    <>
      <Card
        style={{
          boxShadow: "none",
          backgroundColor: "#EFF2F4",
          margin: "0px 20px",
        }}>
        <CardHeader text>
          <CardText
            style={{
              padding: "0px 27px",
              backgroundColor: "#031C30",
              color: "white",
            }}>
            <Grid container justifyContent="space-between">
              <Grid item xs={2} sm={4} xl={4} md={4}>
                <h1 style={{ fontSize: "18px" }}>
                  Vendor Financing Utilization Report
                </h1>
              </Grid>
            </Grid>
          </CardText>
        </CardHeader>
        <CardBody>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={6} md={2}>
              <Typography>Vendor</Typography>
              <Autocomplete
                sx={{
                  "& .MuiInputBase-root": {
                    height: "30px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiInputBase-input": {
                    marginTop: "-4px", // Adjust this value to move the text up
                    fontSize: 15,
                  },
                }}
                id="Vendor"
                options={vendors}
                classes={{ option: classes.option }}
                size="small"
                name="Vendor"
                value={formState.Vendor}
                getOptionLabel={(option) =>{
                  const isBlocked = option?.ALL_COMPANY_CODE === "X";
                  return (option !== "" &&
                    `${
                      option?.Vendor_Code !== "-1"
                        ? `${option?.Vendor_Code}-`
                        : ""
                    }${option?.Vendor_Name}${isBlocked ? "(Blocked)" : ""}`) ||
                  ""
                }
                }
                loading={vendorLoading}
                onChange={(event, newValue) => {
                  autocompleteChangeHandler("Vendor", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    // sx={{ input: { color: "#888888" } }}
                    {...params}
                    name=""
                    required
                    value={""}
                    onChange={(event) => {
                      getVendorDetail(
                        event.target.value,
                        setVendors,
                        setVendorLoading
                      );
                      getLcsLandingPage(
                        setLcs,
                        setLcsLoading,
                        formState,
                        setCount
                      );
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid item md={2} xs={12} style={{ paddingTop: "10px" }}>
            <Link to="/newLc" target="_blank">
              <Button
                variant="contained"
                size="large"
                color="secondary"
                sx={{
                  padding: "3px 4%",
                  width: "-webkit-fill-available",
                }}

                // onClick={newInvoiceFun}
                // onClick={() => navigate("/newInvoice")}
              >
                New Vendor Finance LC
              </Button>           
            </Link>           
          </Grid>
        </CardBody>
      </Card>
      <Card
        className="scrollable"
        style={{
          margin: "0px 38px",
          boxShadow: "rgba(164, 196, 226, 0.6) 2px 5px 10px 1px",
        }}>
        <CardBody>
          <div style={{ backgroundColor: "#FFFFFF" }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={5} lg={4}>
                <TextField
                  placeholder="Enter keyword..."
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30,
                    },
                  }}
                  fullWidth={true}
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  type="text"
                  name="Generic"
                  value={formState.Generic}
                  onChange={(e) => {
                    setFormState((formState) => ({
                      ...formState,
                      Generic: e.target.value,
                    }));
                  }}
                  style={{ marginTop: "-20px" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <IconButton>
                          <SearchOutlinedIcon sx={{ color: "#0095DA" }} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />               
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={12} mt={-6}>         
                <IconButton
                  size="sm"
                  sx={{ float: "right" }}
                  onClick={refreshLCS}>
                  <Refresh />
                </IconButton>               
              </Grid>
              <Button  
                              variant="contained"
                                  size="small"
                                  color="secondary"
                                  style={{
                                    float:'right',
                                    marginLeft: "6px",
                                    padding: "9px",
                                    marginTop: "17px",
                                    height: 35,
                                  }}
                                  onClick={exportVendorLcsToExcel}
                                >Export LCs</Button>
            </Grid>
            <Grid container spacing={0} mt={1} style={{ overflowX: "auto" }}>
              <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "0" }}>
                <VendorFinancingLCTable
                  formState={formState}
                  setFormState={setFormState}
                  loading={lcLoading}
                  lcList={vendorLcs}
                />
              </Grid>
            </Grid>
            <TablePagination
              rowsPerPageOptions={[25, 50, 100, 500, 1000]}
              component="div"
              count={count}
              rowsPerPage={formState.RowsOfPage}
              page={parseInt(formState.PageNo) - 1}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default VendorFinancingLc;
